import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';

function App() {

    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");

    const [ledgers, setLedger] = useState([]);
    const [selectcedLedger, setSelectedLedgr] = useState(null);
    const [selectcedMain, setSelectedMain] = useState(null);
    const [selectcedSub, setSelectedSub] = useState(null);

    const [inputValue, setInputValue] = useState('');

    const getLedger = async () => {
        try {
            const response = await axios.get(
                "https://api.trucoo.in/ledger/",
                {
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": "erpTrucoo",
                },
                }
            );

            if (response.data.status === "success") {
                setLedger(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(()=>{
        getLedger();
    },[]);

    const handleGroup = (type, ledger, group) => {
        if(type === 'main'){
            setSelectedLedgr(null);
            setSelectedMain(ledger);
            setSelectedSub(group);
        }else{
            setSelectedMain(null);
            setSelectedSub(null);
            setSelectedLedgr(ledger);
        }
    };
    
    const addLedger = async () => {

        let sendData = {};
        if(selectcedLedger && !selectcedMain && !selectcedSub){
            sendData = {
                type: 'mainGroup',
                ledger: selectcedLedger?.id,
                name: inputValue
            };
        }else if(!selectcedLedger && selectcedMain && selectcedSub){
            sendData = {
                type: 'subGroup',
                ledger: selectcedMain?.id,
                main: selectcedSub?.id,
                name: inputValue
            };
        }else{
            alert('Something went wrong!');
            return null;
        }

        try {
            const response = await axios.post(
                "https://api.trucoo.in/ledger/add-ledger/", sendData,{
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": "erpTrucoo",
                    },
                }
            );

            if (response.data.status === "success") {
                getLedger();
                setSelectedMain(null);
                setSelectedSub(null);
                setSelectedLedgr(null);
                setInputValue('');
            }
        } catch (error) {
            console.error(error);
        }
    };

return(
<>
    <Header />
    <Sidebar />
    {selectcedLedger &&
    <div class="popup-overlay">
        <div class="popup">
            <button className='btn btn-sm btn-danger' style={{float: 'right'}} onClick={()=>setSelectedLedgr(null)}>x</button>
            <h5 className='mt-2 mb-4'>Add Ledger to <span className='text-warning'>{selectcedLedger?.masterName}</span></h5>
            
            <div class="form-group">
                <input className='form-control' placeholder='Enter ledger name...' value={inputValue} onChange={(e)=> setInputValue(e.target.value)} />
                <button className='btn btn-sm btn-success mt-4' onClick={addLedger}>Add Ledger</button>
            </div>
        </div>
    </div>
    }

    {selectcedMain && selectcedSub &&
    <div class="popup-overlay">
        <div class="popup">
            <button className='btn btn-sm btn-danger' style={{float: 'right'}} onClick={() => {setSelectedMain(null); setSelectedSub(null);}}>x</button>
            <h5 className='mt-2 mb-4'>Add Ledger to <span className='text-warning'>{selectcedMain?.masterName} / {selectcedSub.mainGroupName}</span></h5>
            
            <div class="form-group">
                <input className='form-control' placeholder='Enter ledger name...' value={inputValue} onChange={(e)=> setInputValue(e.target.value)} />
                <button className='btn btn-sm btn-success mt-4' onClick={addLedger}>Add Ledger</button>
            </div>
        </div>
    </div>
    }

    <div class="content-wrapper">
        <div class="container-full">
            <section class="content">
                <div class="box">
                    <div class="box-header with-border">
                        <h4 class="box-title">Ledger Data</h4>
                        <p class="mb-0 box-subtitle">Ledger Management</p>
                    </div>
                    <div class="box-body">
                        <div className="row">
                            {ledgers?.map((ledger, ledgerIndex) => (
                                <div className="col-md-12 col-lg-3 col-xl-3" key={ledgerIndex}>
                                    <div className="card border-radius-10">
                                        <div className="flex border-radius-10" style={{justifyContent: 'space-between'}}>
                                            <p className="m-2 p-2 text-bold border-bottom">
                                                {ledger?.masterName}
                                            </p>
                                            <button className='btn btn-sm btn-warning m-2' onClick={()=>handleGroup('ledger', ledger, null)} >
                                                <i className='fa fa-plus fs-10'></i>
                                            </button>
                                        </div>

                                        <div>
                                            {ledger?.main?.map((mainGroup, mainIndex) => (
                                                <div className='card p-2' key={mainIndex}>
                                                    <div className='flex' style={{justifyContent: 'space-between'}}>
                                                        <button className="btn btn-sm btn-primary m-2" style={{minWidth: '80%'}}>
                                                            {mainGroup?.mainGroupName}
                                                        </button>
                                                        <button className='btn btn-sm btn-warning m-2' onClick={()=>handleGroup('main', ledger, mainGroup)} >
                                                            <i className='fa fa-plus fs-10'></i>
                                                        </button>
                                                    </div>
                                                    {mainGroup?.sub?.map((subGroup, subIndex) => (
                                                        <div key={subIndex} className="ms-3">
                                                            <p className='fs-12 m-1'>
                                                                {subGroup?.subGroupName}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default App;